module.exports = __webpack_public_path__ + "static/ash-cf41b99f28cf6a29b4073a7644ac412f.png";